import Vue from "vue";
import notifications from "vue-notification";

Vue.use(notifications);
